const ua = typeof window == 'undefined' ? '' : navigator.userAgent

export const isMobile = /mobile/i.test(ua)



// WEBPACK FOOTER //
// ./src/shared/platform-info.ts